
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import InputSelect from "../../shared/input/new/InputSelect"
import InputText from "../../shared/input/new/InputText"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import {  deleteRentalCar } from "../../../features/ilanlar/ilanlarSlice"
import { adminKiralikAracDelete, adminKiralikAracUpdate } from "../../../features/admin3/admin3Slice"
import InputDate from "../../shared/input/new/InputDate"
import moment from "moment"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 500px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding-top: 20px;
        align-items: center;
        overflow: auto;
        position: relative;
        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .inputs{
                display: flex;
                flex-direction: column;
                gap: 15px;
                width: 70%;
                margin-top: 30px;
                padding-inline: 30px;
                .row{
                    width: 100%;
                }
            }

            .btn-group{
                display: flex;
                align-items: center;
                margin-top: 20px;
                position: sticky;
                bottom: 0;
                justify-content: center;
                background-color: white;
                gap: 15px;
                width: 100%;
                z-index: 10;
                height: 80px;
            }
        }
        
    }

`

const selectData = [
    {
        id:1,
        text:"Evet",
        bool: true
    },
    {
        id:1,
        text:"Hayır",
        bool: false
    }
]
    
const AdminRentalCarUpdateModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {selectRentalCar } = useSelector(state => state.ilanlar)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    const [isVehicleRented, setIsVehicleRented] = useState(null)
    const [whyDelete, setWhyDelete] = useState("")
    const [endDate, setEndDate] = useState(moment(selectRentalCar?.advertEndDate).format("YYYY-MM-DD"))

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    
    const handleDelete = () => {
        const data = {
            id: selectRentalCar?.id,
            isVehicleRented: isVehicleRented?.bool,
            advertWithdrawalReason: whyDelete,
            advertEndDate: endDate
        }
        
        dispatch(adminKiralikAracUpdate(data))
      }
   
  return (
    <Container onClick={() => dispatch(showModal(null)) }>
        <div className="modal" onClick={(e)=>{e.stopPropagation(); dispatch(handleActiveSelect(null))}} >
            <PageTopTitle isDiffPage title={"Kiralık Araç Güncelle"}/>

            <div className="content">
                <div className="inputs">
                    <div className="row">
                        <InputSelect data={isVehicleRented?.text} setData={setIsVehicleRented} initialOptions={selectData} name={"isVehicleRented"} labelText={"Araç Kiralandı Mı?"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputText data={whyDelete} setData={(e) => setWhyDelete(e.target.value)} name={"advertWithdrawalReason"} labelText={"İlanı Silme Sebebi"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputDate data={endDate} setData={(e) => setEndDate(e.target.value)} name={"endDate"} labelText={"İlan Bitiş Tarihi"} inputWidth={"100%"} />
                    </div>
                </div>
                <div className="btn-group">
                    <Button width="150px" handleClick={handleDelete} padding="10px" background="#fff" color={"#E85446"}>İlanı Güncelle</Button>
                    <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default AdminRentalCarUpdateModal